export const plugins = {
    dataCarrier: {
        isUploadSubTypeEnabled: true,
    },
};
